import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AerovaleDetalleComponent } from '@despacho/aerovale-detalle/aerovale-detalle.component';
import { AerovalesService } from '@despacho/aerovales.service';
import { ModalAnulacionAerovaleComponent } from '@despacho/modal-anulacion-aerovale/modal-anulacion-aerovale.component';
import { VisorRemitoAerovaleComponent } from '@despacho/visor-remito-aerovale/visor-remito-aerovale.component';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { NgbCalendar, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EstadoAerovale } from '@shared/enums/estadoAerovale';
import { ExportExcelServiceService } from '@shared/exportar-excel/export-excel-service.service';
import { AerovaleIATA } from '@shared/models/despacho/AerovaleIATA';
import { VisorComprobanteComponent } from '@shared/visor-comprobante/visor-comprobante.component';
import { MessageService } from '@shell/message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-iata-aerovales',
  templateUrl: './iata-aerovales.component.html',
  styleUrl: './iata-aerovales.component.scss'
})
export class IataAerovalesComponent implements OnInit {

  buscadorFormControl = new UntypedFormControl();
  fechaDesdeFormControl = new UntypedFormControl();
  fechaHastaFormControl = new UntypedFormControl();
  fechaDesde: Date;
  fechaHasta: Date;
  modelDesde: NgbDateStruct;
  modelHasta: NgbDateStruct;
  aerovalesFiltrados: AerovaleIATA[] = [];
  aerovales: AerovaleIATA[];
  habilitarBotones: boolean = true;
  cargandoComprobante: boolean;
  cargandoAerovales: boolean;
  cargandoAerovaleOrigen: number;
  cargandoAerovaleServicio: number;
  cargandoFactura: number;
  cargandoRemito: number;
  EstadoAerovale = EstadoAerovale;

   estadosOriginal = [
    { valor: 'Anulado',    descripcion: 'Anulado',    seleccionado: false },
    { valor: 'Finalizado', descripcion: 'Finalizado', seleccionado: false }
  ];

  estadosServicio = [
    { valor: 'Anulado',    descripcion: 'Anulado',    seleccionado: false },
    { valor: 'Finalizado', descripcion: 'Finalizado', seleccionado: false },
    { valor: 'Facturado',  descripcion: 'Facturado',  seleccionado: false }
  ];

  constructor(private calendar: NgbCalendar, private aerovalesService: AerovalesService, private exportExcelService: ExportExcelServiceService,
    private comprobanteService: ComprobanteService, private modalService: NgbModal, private messageService: MessageService,
    private spinner: NgxSpinnerService, private datePipe: DatePipe) { }

  ngOnInit() {
    this.modelDesde = this.calendar.getToday();
    this.modelHasta = this.calendar.getToday();
    this.fechaDesde = new Date(this.modelDesde.year, this.modelDesde.month, this.modelDesde.day);
    this.fechaHasta = new Date(this.modelHasta.year, this.modelHasta.month, this.modelHasta.day);
    this.obtenerAerovales();
  }

  obtenerAerovales() {
    if(this.habilitarBotones) {
      this.habilitarBotones = false;
      this.cargandoAerovales = true;
      this.spinner.show('spinnerGrafico');
      this.aerovalesService.getAerovalesIATA(this.getFechaDesde(), this.getFechaHasta()).subscribe(a => {
        this.aerovales = a.sort((x, y) => new Date(y.fechaAerovale).getTime() - new Date(x.fechaAerovale).getTime());
        this.aerovalesFiltrados = this.aerovales.map(av => ({
          ...av,
          cantidad: Number(av.cantidad)
        }));
        this.spinner.hide('spinnerGrafico');
        this.cargandoAerovales = false;
        this.habilitarBotones = true;
      }, () => {
        this.messageService.showErrorMessage("No se pudieron obtener los aerovales.");
        this.cargandoAerovales = false;
        this.spinner.hide('spinnerGrafico');
        this.aerovalesFiltrados = null;
        this.habilitarBotones = true;
      })}
  }

  mostrarComprobante(id: string, index, esFactura) {
    if(this.habilitarBotones) {
      this.habilitarBotones = false;
      this.cargandoComprobante = true;
      if(esFactura) this.cargandoFactura = index;
      this.comprobanteService.obtenerComprobantePorId(id)
        .subscribe(comprobante => {
          const modalRef = this.modalService.open(VisorComprobanteComponent, { centered: true, backdrop: "static", size: 'lg' });
          modalRef.componentInstance.facturaObtenida = comprobante;
          this.cargandoComprobante = false;
          this.cargandoFactura = null;
          this.cargandoAerovaleOrigen = null 
          this.cargandoAerovaleServicio = null;
          this.habilitarBotones = true;
        })
    } 
  }

  mostrarAerovale(id, index, esOrigen) {
    if(this.habilitarBotones) {
      this.habilitarBotones = false;
      this.cargandoComprobante = true;
      esOrigen ? this.cargandoAerovaleOrigen = index : this.cargandoAerovaleServicio = index;
      this.aerovalesService.getAerovalePorIdyTipo(id)
        .subscribe(aerovaleDetalle => {
          const modalRef = this.modalService.open(AerovaleDetalleComponent, { centered: true, backdrop: "static", size: 'lg' });
          modalRef.componentInstance.aerovaleDetalle = aerovaleDetalle;
          this.cargandoComprobante = false;
          this.cargandoAerovaleOrigen = null;
          this.cargandoAerovaleServicio = null;
          this.habilitarBotones = true;
        }, () => {
          this.cargandoAerovaleOrigen = null;
          this.cargandoAerovaleServicio = null;
          this.habilitarBotones = true;
          this.messageService.showErrorMessage("Error al cargar el aerovale");
        });
    }
  }

  exportarExcel() {
    const aerovalesExcel = [];
    this.aerovalesFiltrados.forEach(a => {
      const aerovale = {
        razonSocial: a.razonSocial,
        cuenta: a.cuenta,
        aeroplanta: a.aeroplanta,
        aerovaleOrigen: `${a.aerovaleOrigen.prefijo} - ${a.aerovaleOrigen.numeroAerovale}`,
        estadoOrigen: a.estadoOrigen,
        clienteAImputar: a.clienteImputar,
        cuentaAImputar: a.cuentaImputar,
        aerovaleServicio: `${a.aerovaleServicio.prefijo} - ${a.aerovaleServicio.numeroAerovale}`,
        estadoServicio: a.factura ? "Facturado" : a.estadoServicio,
        fechaAerovale: this.datePipe.transform(a.fechaAerovale, 'dd-MM-yyyy'),
        cantidad: a.remito?.detalles[0].cantidad,
        remito: a.remito ? `${a.remito?.prefijo} - ${a.remito?.numeroRemito}` : "",
        factura: a.factura ? a.factura?.factura : "",
        fechaFactura: this.datePipe.transform(a.factura?.fechaFactura, 'dd-MM-yyyy')
    }
    aerovalesExcel.push(aerovale)}
   );
    this.exportExcelService.exportAsExcelFile(aerovalesExcel, "aerovales_IATA_" + this.datePipe.transform(this.fechaDesde, 'dd-MM-yyyy') + "_a_"+this.datePipe.transform(this.fechaHasta, 'dd-MM-yyyy'));
  }

  verRemito(aerovale: AerovaleIATA, index) {
    this.cargandoRemito = index;
    forkJoin({
      aerovale: this.aerovalesService.getAerovalePorIdyTipo(aerovale.aerovaleServicio.id),
      remito: this.comprobanteService.getRemitoAerovale(aerovale.aerovaleServicio.id)
    })
      .subscribe(result => {
        const modalRef = this.modalService.open(VisorRemitoAerovaleComponent, { centered: true, size: 'lg' });
        modalRef.componentInstance.aerovaleDetalle = result.aerovale;
        modalRef.componentInstance.remitoFox = result.remito;
        this.cargandoRemito = null;
      });
  }

  filtrarAerovales() {
    this.aerovalesFiltrados = this.aerovales.filter(aerovale => {
  
      const coincideBusqueda = this.buscadorFormControl.value
        ? aerovale.razonSocial.toLowerCase().includes(this.buscadorFormControl.value.toLowerCase()) ||
          aerovale.cuenta.toLowerCase().includes(this.buscadorFormControl.value.toLowerCase()) || 
          String(aerovale.aerovaleOrigen.numeroAerovale).toLowerCase().includes(this.buscadorFormControl.value.toLowerCase()) ||
          String(aerovale.aerovaleServicio.numeroAerovale).toLowerCase().includes(this.buscadorFormControl.value.toLowerCase())
        : true;
  
      const estadosOrigenSeleccionados = this.estadosOriginal
        .filter(e => e.seleccionado)
        .map(e => e.valor);
  
      const estadosServicioSeleccionados = this.estadosServicio
        .filter(e => e.seleccionado)
        .map(e => e.valor);
  
      const coincideEstadoOrigen = this.coincideEstado(aerovale.estadoOrigen, estadosOrigenSeleccionados);
  
      const servicioNoFacturado = estadosServicioSeleccionados.filter(e => e !== 'Facturado');
      const filtrarFacturado = estadosServicioSeleccionados.includes('Facturado');
  
      const coincideEstadoServicio =
        (servicioNoFacturado.length > 0 ? this.coincideEstado(aerovale.estadoServicio, servicioNoFacturado) : false)
        || (filtrarFacturado ? (aerovale.factura !== null) : false)
        || (estadosServicioSeleccionados.length === 0);
  
      return coincideBusqueda && coincideEstadoOrigen && coincideEstadoServicio;
    });
  }
  
  private coincideEstado(estadoReal: string, estadosSeleccionados: string[]): boolean {
    if (!estadosSeleccionados || estadosSeleccionados.length === 0) {
      return true;
    }
  
    for (const est of estadosSeleccionados) {
      if (est === 'Anulado' && estadoReal === 'Anulado') {
        return true;
      }
      if (est === 'Finalizado' && (estadoReal === 'Finalizado' || estadoReal === 'FinalizadoSinFirma')) {
        return true;
      }
    }
  
    return false;
  }
  
  

  formatDate(year, month, day, hour, minute, seconds): string {
    return year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + seconds.toLocaleString(undefined, { minimumIntegerDigits: 2 });
  }

  getFechaDesde() {
    return this.formatDate(this.modelDesde.year, this.modelDesde.month, this.modelDesde.day, 0, 0, 0);
  }

  getFechaHasta() {
    return this.formatDate(this.modelHasta.year, this.modelHasta.month, this.modelHasta.day, 23, 59, 59);
  }

  anularAerovale(id){
    this.aerovalesService.getAerovalePorIdyTipo(id).subscribe(a => {
      const modalRef = this.modalService.open(ModalAnulacionAerovaleComponent, { centered: true, size: 'lg', backdrop: 'static' });
      modalRef.componentInstance.detalle = a;
      modalRef.result.then(() => {
        this.obtenerAerovales();
      });
    })
  }

  esAnulado(aerovale) {
    return aerovale.estado == EstadoAerovale.Anulado;
  }

  toggleDatepicker(e: any) {
    e.toggle();
  }

  get buscador() {
    return this.buscadorFormControl.value;
  }

}
